
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { explainFirebaseError, signInAdminWithEmail } from "data/firebase";
import { sessionRepo } from "data/repositories/sessionRepo";

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  Alert,
} from "reactstrap";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError("E-posta adresi gerekli.");
      return;
    }
    if (!password.trim()) {
      setError("Şifre gerekli.");
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      const session = await signInAdminWithEmail(email.trim(), password.trim());
      sessionRepo.signIn(session);
      navigate("/admin/admin-panel");
    } catch (err) {
      setError(explainFirebaseError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Destinasyon 360 yönetici girişi</small>
            </div>
            {error && <Alert color="danger">{error}</Alert>}
            <Form role="form" onSubmit={(event) => void handleSubmit(event)}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="E-posta"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={submitting}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Şifre"
                    type="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={submitting}
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <Button className="my-4" color="primary" type="submit" disabled={submitting}>
                  {submitting ? "Giriş yapılıyor…" : "Giriş yap"}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Login;
